export enum FinalizeStepProcessType {
  NotInitialized = 'notInitialized',
  OccupancyConfirmation = 'occupancyConfirmation',
  ChargePosting = 'chargePosting',
  Finalized = 'finalized'
}



// WEBPACK FOOTER //
// ./src/components/Attendant/RoomDetails/body/FinalizeTaskProcess/FinalizeStepProcessType.ts